"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Highcharts = __importStar(require("highcharts"));
const highcharts_react_official_1 = __importDefault(require("highcharts-react-official"));
const accessibility_1 = __importDefault(require("highcharts/modules/accessibility"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const styled_components_1 = __importStar(require("styled-components"));
accessibility_1.default(Highcharts);
const StyledContainer = styled_components_1.default.div `
  ${(props) => {
    return (props.seriesLength &&
        styled_components_1.css `
        .highcharts-series-${props.seriesLength - 1} {
          stroke-dasharray: 1, 8;
          stroke-linecap: round;
          stroke-miterlimit: 16;
        }
      `);
}}
`;
const formatAmount = (amount) => {
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
    });
    return formatter.format(Number(amount));
};
const fourColors = [
    '#33c2ff',
    '#9aead6',
    '#9e7dcf',
    '#4e3473',
];
const sevenColors = [
    '#33c2ff',
    '#9aead6',
    '#9e7dcf',
    '#4e3473',
    '#27be99',
    tokens.ColorChartingPurple700,
    tokens.ColorChartingPurple300,
];
const elevenColors = [
    tokens.ColorChartingBlue500,
    tokens.ColorChartingBlue100,
    tokens.ColorChartingBrightBlue900,
    tokens.ColorChartingBrightBlue500,
    tokens.ColorChartingBrightBlue100,
    tokens.ColorChartingTeal900,
    tokens.ColorChartingTeal500,
    tokens.ColorChartingTeal100,
    tokens.ColorChartingPurple900,
    tokens.ColorChartingPurple500,
    tokens.ColorChartingPurple100
];
const fifteenColors = [
    tokens.ColorBrandInteractiveBlue,
    tokens.ColorChartingBlue500,
    tokens.ColorChartingBlue100,
    tokens.ColorChartingBrightBlue900,
    tokens.ColorChartingBrightBlue700,
    tokens.ColorChartingBrightBlue500,
    tokens.ColorChartingBrightBlue100,
    tokens.ColorChartingTeal900,
    tokens.ColorChartingTeal700,
    tokens.ColorChartingTeal500,
    tokens.ColorChartingTeal100,
    tokens.ColorChartingPurple900,
    tokens.ColorChartingPurple700,
    tokens.ColorChartingPurple500,
    tokens.ColorChartingPurple100
];
const mapColorPallete = {
    1: fourColors,
    2: fourColors,
    3: fourColors,
    4: fourColors,
    5: sevenColors,
    6: sevenColors,
    7: sevenColors,
    8: elevenColors,
    9: elevenColors,
    10: elevenColors,
    11: elevenColors,
    12: fifteenColors,
    13: fifteenColors,
    14: fifteenColors,
    15: fifteenColors
};
let crosshairLine = null, crosshairPointerCircle = null, 
// crosshairAgeCircle = null,
// crosshairAgeLabel = null,
alertIcon = null, spouseRetirementStartAgeIcon = null, spouseRetirementStartAgeTooltip = null, startAgeLabel = null, endAgeLabel = null;
class RetirementIncomeChart extends React.Component {
    constructor(props) {
        super(props);
        this.chartRenderFunction = ({ target: c }) => {
            const { participantAge, runOutAge, retirementAge, spouseRetirementStartAge, hoveredAge } = this.props.data;
            const startAge = participantAge[0];
            const endAge = participantAge[participantAge.length - 1];
            const chartRenderer = c.renderer, chartLeft = c.plotLeft, chartTop = c.plotTop, chartHeight = c.plotHeight;
            const s = c.series[0];
            const startAgePosition = s.points[0] ? s.points[0].clientX : null;
            const hoveredAgePosition = s.points[hoveredAge - startAge]
                ? s.points[hoveredAge - startAge].clientX
                : null;
            const endAgePosition = s.points[participantAge.length - 1]
                ? s.points[participantAge.length - 1].clientX
                : null;
            const alertAgePosition = runOutAge === null
                ? null
                : s.points[runOutAge - retirementAge]
                    ? s.points[runOutAge - retirementAge].clientX
                    : null;
            const spouseRetirementStartAgePosition = spouseRetirementStartAge === null
                ? null
                : s.points[spouseRetirementStartAge - retirementAge]
                    ? s.points[spouseRetirementStartAge - retirementAge].clientX
                    : null;
            const ageStyleObj = {
                color: '#3b4b59',
                "font-size": "14px",
                "font-family": "Nimbus Sans Regular"
            };
            const attrObj = {
                zIndex: 6
            };
            if (startAgeLabel) {
                startAgeLabel.destroy();
            }
            if (endAgeLabel) {
                endAgeLabel.destroy();
            }
            if (alertIcon) {
                alertIcon.destroy();
                alertIcon = null;
            }
            if (spouseRetirementStartAgeIcon) {
                spouseRetirementStartAgeIcon.destroy();
                spouseRetirementStartAgeIcon = null;
            }
            if (crosshairLine && crosshairLine.d) {
                crosshairLine.destroy();
                crosshairPointerCircle.destroy();
                // crosshairAgeCircle.destroy();
                // crosshairAgeLabel.destroy();
            }
            if (startAgePosition) {
                startAgeLabel = chartRenderer
                    .label(startAge, chartLeft + startAgePosition - 10, chartHeight + chartTop + 8)
                    .attr(attrObj)
                    .css(ageStyleObj)
                    .add();
            }
            if (endAgePosition) {
                endAgeLabel = chartRenderer
                    .label(endAge, chartLeft + endAgePosition - 10, chartHeight + chartTop + 8)
                    .attr(attrObj)
                    .css(ageStyleObj)
                    .add();
            }
            if (alertAgePosition) {
                alertIcon = chartRenderer
                    .image(`data:image/svg+xml;base64,${tokens.AssetIconAlert}`, chartLeft + alertAgePosition - 12, chartHeight + chartTop + 5, 24, 24)
                    .add();
            }
            if (spouseRetirementStartAgePosition) {
                spouseRetirementStartAgeIcon = chartRenderer
                    .image(`data:image/svg+xml;base64,${tokens.AssetIconSpouse}`, chartLeft + spouseRetirementStartAgePosition - 8, chartHeight + chartTop + 8, 16, 16)
                    .on("mouseover", function () {
                    spouseRetirementStartAgeTooltip = chartRenderer
                        .image(`data:image/svg+xml;base64,${tokens.AssetIconSpouseRetires}`, chartLeft + spouseRetirementStartAgePosition, chartHeight + chartTop - 7, 157, 72)
                        .attr({ zIndex: 21 })
                        .add();
                })
                    .on("mouseout", function () {
                    spouseRetirementStartAgeTooltip.destroy();
                })
                    .add();
            }
            if (hoveredAgePosition) {
                const chartHeightPosition = chartTop + chartHeight;
                crosshairLine = chartRenderer
                    .path([
                    "M",
                    chartLeft + hoveredAgePosition,
                    chartHeightPosition,
                    "L",
                    chartLeft + hoveredAgePosition,
                    chartHeightPosition + 50
                ])
                    .attr({
                    "stroke-width": 2,
                    stroke: tokens.ColorBrandInteractiveBlue,
                    zIndex: 6
                })
                    .add();
                crosshairPointerCircle = chartRenderer
                    .circle(chartLeft + hoveredAgePosition, chartHeightPosition, 4)
                    .attr({
                    fill: "#FFFFFF",
                    stroke: tokens.ColorBrandInteractiveBlue,
                    "stroke-width": 2,
                    zIndex: 6,
                    opacity: 0
                })
                    .add();
                // crosshairAgeCircle = chartRenderer
                //   .circle(chartLeft + hoveredAgePosition, chartHeightPosition + 20, 12)
                //   .attr({
                //     fill: "white",
                //     stroke: tokens.ColorBrandInteractiveBlue,
                //     "stroke-width": 2,
                //     zIndex: 21
                //   })
                //   .add();
                // crosshairAgeLabel = chartRenderer
                //   .label(
                //     hoveredAge,
                //     chartLeft + hoveredAgePosition - 11,
                //     chartHeightPosition + 10
                //   )
                //   .css({
                //     color: tokens.ColorBrandInteractiveBlue,
                //     "font-size": "12px",
                //     "font-family": "Nimbus Sans Bold"
                //   })
                //   .attr({
                //     zIndex: 21,
                //     "stroke-width": 2
                //   })
                //   .add();
            }
        };
        this.tooltipFormatter = a => {
            const { participantAge, socialSecurityStartAge, socialSecurityAmount, spouseSocialSecurityStartAge, spouseSocialSecurityAmount, pensionStartAge, spousePensionStartAge } = this.props.data;
            const startAge = participantAge[0];
            const chartRenderer = a.chart.renderer, chartLeft = a.chart.plotLeft, chartTop = a.chart.plotTop, chartHeight = a.chart.plotHeight;
            if (crosshairLine && crosshairLine.d) {
                crosshairLine.destroy();
                crosshairPointerCircle.destroy();
                // crosshairAgeCircle.destroy();
                // crosshairAgeLabel.destroy();
            }
            const { x: ageOffset } = a.chart.hoverPoint;
            const points = a.chart.hoverPoints;
            const { plotX, plotY } = points[0];
            const xPosition = chartLeft + plotX;
            const yPosition = chartTop + plotY;
            const chartHeightPosition = chartTop + chartHeight;
            crosshairLine = chartRenderer
                .path([
                "M",
                xPosition,
                yPosition - 20,
                "L",
                xPosition,
                chartHeightPosition
            ])
                .attr({
                "stroke-width": 2,
                stroke: tokens.ColorBrandInteractiveBlue,
                zIndex: 6
            })
                .add();
            crosshairPointerCircle = chartRenderer
                .circle(xPosition, chartHeightPosition, 4)
                .attr({
                fill: "#FFFFFF",
                stroke: tokens.ColorBrandInteractiveBlue,
                "stroke-width": 2,
                zIndex: 6
            })
                .add();
            // crosshairAgeCircle = chartRenderer
            //   .circle(xPosition, yPosition - 20, 12)
            //   .attr({
            //     fill: "white",
            //     stroke: tokens.ColorBrandInteractiveBlue,
            //     "stroke-width": 2,
            //     zIndex: 21
            //   })
            //   .add();
            // crosshairAgeLabel = chartRenderer
            //   .label(startAge + ageOffset, xPosition - 11, yPosition - 31)
            //   .css({
            //     color: tokens.ColorBrandInteractiveBlue,
            //     "font-size": "12px",
            //     "font-family": "Nimbus Sans Bold"
            //   })
            //   .attr({
            //     zIndex: 21,
            //     "stroke-width": 2
            //   })
            //   .add();
            let incomeGoal = 0, tooltipHTML = "", whatYouCanSpend = 0, hoveredAge = startAge;
            const ps = points;
            tooltipHTML = points.reduce(function (s, point, i) {
                if (i === ps.length - 1) {
                    incomeGoal = point.y;
                    hoveredAge = startAge + point.x;
                    return s + "";
                }
                hoveredAge = startAge + point.x;
                whatYouCanSpend = whatYouCanSpend + point.y;
                let seriesName = point.series.name;
                if (seriesName === "Social Security*") {
                    let participantSSIncluded = false, spouseSSIncluded = false;
                    if (socialSecurityStartAge &&
                        socialSecurityStartAge <= hoveredAge &&
                        socialSecurityAmount !== 0) {
                        seriesName = "Your Social Security*";
                        participantSSIncluded = true;
                    }
                    if (spouseSocialSecurityStartAge &&
                        spouseSocialSecurityStartAge <= hoveredAge &&
                        spouseSocialSecurityAmount !== 0) {
                        seriesName = "Spouse Social Security*";
                        spouseSSIncluded = true;
                    }
                    if (participantSSIncluded && spouseSSIncluded) {
                        seriesName = "Household Social Security*";
                    }
                    if (!participantSSIncluded && !spouseSSIncluded) {
                        seriesName = "";
                    }
                }
                if (seriesName === "Pension*") {
                    let participantPensionIncluded = false, spousePensionIncluded = false;
                    if (pensionStartAge && pensionStartAge <= hoveredAge) {
                        seriesName = "Your Pension*";
                        participantPensionIncluded = true;
                    }
                    if (spousePensionStartAge && spousePensionStartAge <= hoveredAge) {
                        seriesName = "Spouse Pension*";
                        spousePensionIncluded = true;
                    }
                    if (participantPensionIncluded && spousePensionIncluded) {
                        seriesName = "Household Pension*";
                    }
                    if (!participantPensionIncluded && !spousePensionIncluded) {
                        seriesName = "";
                    }
                }
                if (!seriesName) {
                    return s;
                }
                return (s +
                    `<div style="display: flex; justify-content: space-between; margin-top: 10px">
            <div style="display: flex; align-items: center">
              <div style="background-color:${point.color}; height: 12px; width: 12px; margin: 0px 8px"></div>
              ${seriesName}
            </div>
            <div>${formatAmount(point.y)}</div>
        </div>`);
            }, "");
            tooltipHTML =
                `<div style="display: flex;flex-direction: column;width: 290px; font-family: Nimbus Sans Regular;padding: 16px;z-index: 9999 !important; opacity: 1;background-color: white;">
      <div style="display: flex; justify-content: space-between;font-family: Nimbus Sans Bold">
        <div>Age ${hoveredAge} Income Goal</div>
        <div>${formatAmount(incomeGoal)}</div>
      </div>
      <div style="display: flex; justify-content: space-between;font-family: Nimbus Sans Bold; margin-top: 8px">
        <div>What You Can Spend*</div>
        <div>${formatAmount(whatYouCanSpend)}</div>
      </div>` +
                    tooltipHTML +
                    `<div style="display: flex; justify-content: space-between; margin-top: 16px; font-family: Nimbus Sans Bold">
          <div>Gap</div>
          <div style="color:${incomeGoal - whatYouCanSpend > 0
                        ? tokens.ColorFunctionalRed500
                        : tokens.ColorFunctionalGreen500}">${formatAmount(Math.abs(incomeGoal - whatYouCanSpend))}</div>
      </div>
      <div style="font-family: Nimbus Sans Regular; color: ${tokens.ColorGrey600}; font-size: 12px; line-height: 18px; margin-top: 24px;">      
      *Higher withdrawal amounts may be necessary<br> due to withholding requirements or the need to<br> pay taxes. Estimated taxes have been taken<br> out of Social Security and any applicable<br> pension amounts.
      </div>
      </div>`;
            return tooltipHTML;
        };
        this.state = {
            options: {
                title: {
                    text: ""
                },
                chart: {
                    events: {
                        render: this.chartRenderFunction
                    }
                },
                responsive: {
                    rules: [
                        {
                            condition: {
                                callback: function () {
                                    if (window.innerWidth < 768) {
                                        return true;
                                    }
                                    return false;
                                }
                            },
                            chartOptions: {
                                chart: {
                                    width: 343,
                                    height: 185
                                },
                                tooltip: {
                                    enabled: false
                                },
                                legend: {
                                    enabled: false
                                }
                            }
                        },
                        {
                            condition: {
                                callback: function () {
                                    if (window.innerWidth >= 768) {
                                        return true;
                                    }
                                    return false;
                                }
                            },
                            chartOptions: {
                                tooltip: {
                                    enabled: false
                                },
                                legend: {
                                    enabled: false
                                }
                            }
                        },
                        {
                            condition: {
                                callback: function () {
                                    if (window.innerWidth > 768 && window.innerWidth <= 1024) {
                                        return true;
                                    }
                                    return false;
                                }
                            },
                            chartOptions: {
                                chart: {
                                    width: 432,
                                    height: 274
                                },
                                tooltip: {
                                    enabled: false
                                },
                                legend: {
                                    enabled: false
                                }
                            }
                        },
                        {
                            condition: {
                                callback: function () {
                                    if (window.innerWidth > 1024) {
                                        return true;
                                    }
                                    return false;
                                }
                            },
                            chartOptions: {
                                tooltip: {
                                    distance: 24,
                                    outside: true,
                                    borderColor: "none",
                                    backgroundColor: "white",
                                    shared: true,
                                    useHTML: true,
                                    formatter: this.tooltipFormatter,
                                    enabled: false
                                },
                                legend: {
                                    enabled: false,
                                }
                            }
                        }
                    ]
                },
                colors: mapColorPallete[props.data.series.length - 1],
                xAxis: {
                    tickInterval: 1,
                    tickColor: "transparent",
                    tickLength: 30,
                    lineColor: tokens.ColorGrey600,
                    lineWidth: 2,
                    labels: {
                        enabled: false
                    },
                    title: {
                        align: 'low',
                        text: 'Age',
                        y: 4,
                        x: -40,
                        style: {
                            fontFamily: 'Nimbus Sans Regular',
                            fontSize: '14px',
                            color: '#3b4b59'
                        }
                    }
                },
                yAxis: {
                    minorGridLineWidth: 0,
                    minorTickInterval: 10000000000,
                    minorTickColor: '#000000',
                    minorTickWidth: 2,
                    minorTickLength: 50,
                    gridLineColor: "",
                    title: {
                        text: ""
                    },
                    labels: {
                        formatter: function () {
                            const label = this.axis.defaultLabelFormatter.call(this);
                            if (!this.isFirst) {
                                return "$" + label;
                            }
                        },
                        style: {
                            fontFamily: 'Nimbus Sans Regular',
                            fontSize: '14px',
                            color: '#3b4b59'
                        }
                    }
                },
                plotOptions: {
                    column: {
                        stacking: "normal",
                        groupPadding: 0.06,
                        pointPadding: 0,
                        events: {
                            legendItemClick: function () {
                                return false;
                            }
                        },
                        states: {
                            hover: {
                                enabled: false,
                                brightness: 0
                            }
                        },
                        point: {
                            events: {
                                mouseOut: () => {
                                    if (crosshairLine && crosshairLine.d) {
                                        crosshairLine.destroy();
                                        crosshairPointerCircle.destroy();
                                        // crosshairAgeCircle.destroy();
                                        // crosshairAgeLabel.destroy();
                                    }
                                }
                            }
                        }
                    },
                    line: {
                        color: tokens.ColorBrandInteractiveBlue,
                        enableMouseTracking: true,
                        visible: true,
                        lineWidth: 4,
                        marker: {
                            enabled: false
                        },
                        states: {
                            hover: {
                                enabled: false
                            },
                            inactive: {
                                opacity: 0
                            }
                        }
                    }
                },
                series: [...props.data.series],
                credits: {
                    enabled: false
                }
            }
        };
    }
    static getDerivedStateFromProps(props, state) {
        return Object.assign(Object.assign({}, state), { options: Object.assign(Object.assign({}, state.options), { series: [...props.data.series] }) });
    }
    render() {
        const { data } = this.props;
        const { options } = this.state;
        if (!data) {
            return null;
        }
        const { simulationType, participantAge, series } = this.props.data;
        if (!simulationType || !participantAge || participantAge.length === 0) {
            return null;
        }
        return (React.createElement(StyledContainer, { seriesLength: series.length },
            React.createElement(highcharts_react_official_1.default, { highcharts: Highcharts, options: options })));
    }
}
exports.default = RetirementIncomeChart;
//# sourceMappingURL=RetirementIncomeChart.js.map